export default {
  club_name: 'Björklöven',
  club_name_short: 'bjorkloven',
  stadium_name: '',
  staging_url: 'https://bjorkloven.api.fangroup.io',
  prod_url: 'https://bjorkloven.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/bjorkloven',
  club_logo: '/assets/teams/bjorkloven.png',
  app_name: 'bjorkloven',
  websale_name: 'bjorkloven',
  ntb_team_id: 10046,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'bjorkloven',
  monolithEnabled: false,
};
